import React from 'react';
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import CompanyType from "@SearchResults/types/company/Company.type";
import MobileContentContainer from "@Route/features/mobile/components/MobileContentContainer";
import CompanyDetails from "@Route/features/company/components/CompanyDetails";

interface MobileCompanyDetailsProps {
    route: RouteWithAddedPropsAndPricesType,
    company: CompanyType,
}

function MobileCompanyDetails({route, company}: MobileCompanyDetailsProps) {
    const title = `${company.name}`

    return (
        <MobileContentContainer title={title}>
            <CompanyDetails
                company={company}
                route={route}
                hideLetterCode={true}
            />
        </MobileContentContainer>
    );
}

export default MobileCompanyDetails;